var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mBtnMathine",
    on: {
      "click": _vm.showPop
    }
  }, [_c('span', [_vm._v("SLOTS")]), _c('img', {
    attrs: {
      "src": _vm.iconUrl,
      "alt": ""
    }
  }), _vm._m(0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "arc-wrapper"
  }, [_c('div', {
    staticClass: "arc"
  })]);
}];
export { render, staticRenderFns };